/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    AggregatedUptimeResponse,
    ConnectorUptimeSummary,
    DateCentricUptimeTrendItem,
    DeviceUptimeSummary,
    OrgUptimeSummary,
    SiteUptimeSummary,
} from "../models/index";
import {
    AggregatedUptimeResponseFromJSON,
    AggregatedUptimeResponseToJSON,
    ConnectorUptimeSummaryFromJSON,
    ConnectorUptimeSummaryToJSON,
    DateCentricUptimeTrendItemFromJSON,
    DateCentricUptimeTrendItemToJSON,
    DeviceUptimeSummaryFromJSON,
    DeviceUptimeSummaryToJSON,
    OrgUptimeSummaryFromJSON,
    OrgUptimeSummaryToJSON,
    SiteUptimeSummaryFromJSON,
    SiteUptimeSummaryToJSON,
} from "../models/index";

export interface GetAggregatedUptimeRequest {
    from?: string;
    to?: string;
    deviceGroupTags?: Array<string>;
}

export interface GetGlobalUptimeTrendRequest {
    from?: string;
    to?: string;
    deviceGroupTags?: Array<string>;
}

export interface GetGroupedUptimeByConnectorRequest {
    from?: string;
    to?: string;
    deviceGroupTags?: Array<string>;
}

export interface GetGroupedUptimeByDeviceRequest {
    from?: string;
    to?: string;
}

export interface GetGroupedUptimeByOrgRequest {
    from?: string;
    to?: string;
}

export interface GetGroupedUptimeBySiteRequest {
    from?: string;
    to?: string;
}

export interface GetGroupedUptimeTrendByDeviceRequest {
    deviceIdentities: Array<string>;
    from?: string;
    to?: string;
}

export interface GetGroupedUptimeTrendByDeviceGroupRequest {
    deviceGroupTags: Array<string>;
    from?: string;
    to?: string;
}

/**
 *
 */
export class UptimeHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Get a single aggregated uptime value across all device groups (or filtered by specific device group tags). Includes percentage difference from previous period.
     */
    async getAggregatedUptimeRaw(
        requestParameters: GetAggregatedUptimeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<AggregatedUptimeResponse>> {
        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/uptime/aggregated`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            AggregatedUptimeResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get a single aggregated uptime value across all device groups (or filtered by specific device group tags). Includes percentage difference from previous period.
     */
    async getAggregatedUptime(
        requestParameters: GetAggregatedUptimeRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<AggregatedUptimeResponse> {
        const response = await this.getAggregatedUptimeRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get daily uptime trends aggregated globally across all device groups (or filtered by specific device group tags). Returns a single \'global\' entry per day.
     */
    async getGlobalUptimeTrendRaw(
        requestParameters: GetGlobalUptimeTrendRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DateCentricUptimeTrendItem>>> {
        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/uptime/trend/global`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DateCentricUptimeTrendItemFromJSON),
        );
    }

    /**
     * Get daily uptime trends aggregated globally across all device groups (or filtered by specific device group tags). Returns a single \'global\' entry per day.
     */
    async getGlobalUptimeTrend(
        requestParameters: GetGlobalUptimeTrendRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DateCentricUptimeTrendItem>> {
        const response = await this.getGlobalUptimeTrendRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get uptime summaries grouped by connector. Supports OData filtering on connector properties.
     */
    async getGroupedUptimeByConnectorRaw(
        requestParameters: GetGroupedUptimeByConnectorRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<ConnectorUptimeSummary>>> {
        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/uptime/grouped/by-connector`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(ConnectorUptimeSummaryFromJSON),
        );
    }

    /**
     * Get uptime summaries grouped by connector. Supports OData filtering on connector properties.
     */
    async getGroupedUptimeByConnector(
        requestParameters: GetGroupedUptimeByConnectorRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<ConnectorUptimeSummary>> {
        const response = await this.getGroupedUptimeByConnectorRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get uptime summaries grouped by device. Supports OData filtering on device properties.
     */
    async getGroupedUptimeByDeviceRaw(
        requestParameters: GetGroupedUptimeByDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceUptimeSummary>>> {
        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/uptime/grouped/by-device`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceUptimeSummaryFromJSON),
        );
    }

    /**
     * Get uptime summaries grouped by device. Supports OData filtering on device properties.
     */
    async getGroupedUptimeByDevice(
        requestParameters: GetGroupedUptimeByDeviceRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceUptimeSummary>> {
        const response = await this.getGroupedUptimeByDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get uptime summaries grouped by organisation. Supports OData filtering on organisation properties.
     */
    async getGroupedUptimeByOrgRaw(
        requestParameters: GetGroupedUptimeByOrgRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<OrgUptimeSummary>>> {
        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/uptime/grouped/by-org`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(OrgUptimeSummaryFromJSON),
        );
    }

    /**
     * Get uptime summaries grouped by organisation. Supports OData filtering on organisation properties.
     */
    async getGroupedUptimeByOrg(
        requestParameters: GetGroupedUptimeByOrgRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<OrgUptimeSummary>> {
        const response = await this.getGroupedUptimeByOrgRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get uptime summaries grouped by site. Supports OData filtering on site properties.
     */
    async getGroupedUptimeBySiteRaw(
        requestParameters: GetGroupedUptimeBySiteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<SiteUptimeSummary>>> {
        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/uptime/grouped/by-site`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(SiteUptimeSummaryFromJSON),
        );
    }

    /**
     * Get uptime summaries grouped by site. Supports OData filtering on site properties.
     */
    async getGroupedUptimeBySite(
        requestParameters: GetGroupedUptimeBySiteRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<SiteUptimeSummary>> {
        const response = await this.getGroupedUptimeBySiteRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get daily uptime trends for specific devices. Requires a list of device identities (max 10).
     */
    async getGroupedUptimeTrendByDeviceRaw(
        requestParameters: GetGroupedUptimeTrendByDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DateCentricUptimeTrendItem>>> {
        if (requestParameters["deviceIdentities"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentities",
                'Required parameter "deviceIdentities" was null or undefined when calling getGroupedUptimeTrendByDevice().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["deviceIdentities"] != null) {
            queryParameters["deviceIdentities"] = requestParameters[
                "deviceIdentities"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/uptime/trend/grouped/by-device`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DateCentricUptimeTrendItemFromJSON),
        );
    }

    /**
     * Get daily uptime trends for specific devices. Requires a list of device identities (max 10).
     */
    async getGroupedUptimeTrendByDevice(
        requestParameters: GetGroupedUptimeTrendByDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DateCentricUptimeTrendItem>> {
        const response = await this.getGroupedUptimeTrendByDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get daily uptime trends for specific device groups (orgs, sites, or service models). Requires a list of device group tags (max 10).
     */
    async getGroupedUptimeTrendByDeviceGroupRaw(
        requestParameters: GetGroupedUptimeTrendByDeviceGroupRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DateCentricUptimeTrendItem>>> {
        if (requestParameters["deviceGroupTags"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTags",
                'Required parameter "deviceGroupTags" was null or undefined when calling getGroupedUptimeTrendByDeviceGroup().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/uptime/trend/grouped/by-device-group`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DateCentricUptimeTrendItemFromJSON),
        );
    }

    /**
     * Get daily uptime trends for specific device groups (orgs, sites, or service models). Requires a list of device group tags (max 10).
     */
    async getGroupedUptimeTrendByDeviceGroup(
        requestParameters: GetGroupedUptimeTrendByDeviceGroupRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DateCentricUptimeTrendItem>> {
        const response = await this.getGroupedUptimeTrendByDeviceGroupRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
